import PortalDocument from "./PortalDocument";
import AbstractContainer from "./AbstractContainer";
import ViewerType from "./DataType";
import Exception from "../../shared/exception/Exception";
import Translate from "../../shared/translation/Translate";
import FunctionHelper from "../../shared/helper/FunctionHelper";

export default class TiffContainer extends AbstractContainer {
	public clean(): void {
		if (this.loaded) {
			this.data.close();
		}

		this.data = undefined;
		this.loaded = false;
	}

	public async loadViewerData(portalDocument: PortalDocument): Promise<Tiff> {
		if (!FunctionHelper.exists(this.data)) {
			throw new Exception(Translate.value("errors.files.corrupt", {ns: "message"}));
		}

		if (this.loaded) {
			return this.data;
		}

		try {
			this.data = new Tiff({buffer: this.data});
			this.loaded = true;
		} catch (exception: any) {
			let portalException: Exception = new Exception(exception.message);
			portalException.originalException = exception;
			throw portalException;
		}

		return this.data;
	}

	public async getNumberOfPages(data: Tiff) {
		return data.countDirectory() + data.currentDirectory();
	}

	public getType(): ViewerType {
		return ViewerType.TIFF;
	}
}